import { render } from "./footerView.vue?vue&type=template&id=95540390"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__